import React, { CSSProperties } from "react";

import dark_delete from "assets/procedure/dark_delete.svg";
import plus from "assets/procedure/delete.svg";

import { Container, PlusIcon } from "./styles";
import { useReadOnly } from "../../contexts/ReadOnlyContext";

type DeletePermissions = {
  exclude?: boolean;
};

export type IDeleteProps = {
  onClick?: () => unknown;
  style?: CSSProperties;
  id?: string;
  widthHeight?: number;
  disabled?: boolean;
  permissions?: DeletePermissions;
};

export const DeleteButton: React.FC<IDeleteProps> = ({
  style,
  onClick,
  id,
  widthHeight,
  disabled,
  permissions,
}) => {
  const ro = useReadOnly();
  const notAllowed = !!disabled || (permissions ? !permissions.exclude : false);
  const isDisabled = ro || notAllowed;

  const handleClick = () => {
    if (!isDisabled && onClick) onClick();
  };

  return (
    <Container
      data-testid={id}
      id={id}
      disabled={isDisabled}
      style={style}
      onClick={handleClick}
      widthHeight={widthHeight}
    >
      <PlusIcon>
        <img src={isDisabled ? dark_delete : plus} alt="" />
      </PlusIcon>
    </Container>
  );
};
